export function getProductsAccumulatedQtyInCart(productId, cart) {
    return parseFloat(cart.filter(i => i.productId == productId).reduce((a, c) => a + parseFloat(c.quantity), 0))
}